/* cc-frame-switch.js - 8 Oct 2026, direct instruction: "please start
   developing an overlay to switch from the grid shop view".

   Swaps every grid tile between the four plain-ground shots - black, white
   and natural box frames, and unframed - so a visitor can see the whole
   collection in the frame they are actually considering.

   Three things it deliberately does NOT do:

   - It does not filter or reload. The server already decided which products
     are on this page and in what order, including the H/V alternation. A
     frame colour is a way of looking at that grid, not a different grid, so
     the URL does not change and nothing reflows.
   - It does not touch a card whose product has no shot in the chosen colour.
     Only products carrying the v4 mock-up set have all four; the rest keep
     the image they had. That is why this can ship before the other 74
     products are uploaded - it lights up per product as they land.
   - It does not preload. Four colours x 24 tiles is 96 files and only one
     colour is ever on screen. The browser fetches a colour the first time
     it is asked for and caches it after that.

   The payload is printed server-side by cc-collection-grid.liquid, same
   pattern as the quick-view data, so switching costs no network request
   beyond the image itself. */
(function () {
  'use strict';

  /* 2026-10-14: 'photo' is the artwork itself, and it leads the list because
     it is the default. The other four are mock-ups of a print on a plain
     ground; the photograph is the product. Before this there was no way back
     to it once a colour had been chosen - see the STORE note below. */
  /* 28 Oct 2026, Charly: "remove the unframed (print only) view and add a
     view with mockup room from the bottom island selector." So 'un' is out
     and 'room' is in.

     'room' is not a stored key. Every print has three room shots, one per
     frame colour, so the room view shows the room shot for whichever colour
     the visitor last chose and defaults to natural. That is what makes
     Black -> In a room do the obvious thing rather than jumping to some
     other colour's living room. ROOM_FALLBACK exists because white is the
     one colour not shot in a room on every print (67 of 75 on 28 Oct). */
  var FORMATS = ['photo', 'blk', 'wht', 'nat', 'room'];
  var COLOURS = ['blk', 'wht', 'nat'];
  var ROOM_FALLBACK = ['nat', 'blk', 'wht'];
  var STORE_KEY = 'cc-frame-view';
  var COLOUR_KEY = 'cc-frame-colour';
  var WIDTHS = [400, 600, 800, 1000, 1200];

  var lastColour = 'nat';
  try {
    var savedColour = sessionStorage.getItem(COLOUR_KEY);
    if (COLOURS.indexOf(savedColour) !== -1) lastColour = savedColour;
  } catch (e) { /* private window */ }

  var bar = document.querySelector('[data-cc-frameswitch]');
  var dataEl = document.getElementById('cc-frame-data');
  if (!bar || !dataEl) return;

  /* 19 Oct 2026, Charly: "the frames changes option doesn't appear on
     destination page". The Destinations page lists prints too, in a
     different structure, so the three things this script used to assume
     are now read from the bar's own attributes and DEFAULT to the shop
     grid's values. The shop grid's markup is unchanged and so is its
     behaviour; Destinations passes its own selectors. One script, so the
     two pages cannot drift into two different ideas of what a frame
     switch does. */
  var gridSel  = bar.getAttribute('data-grid') || '#product-grid';
  var frameSel = bar.getAttribute('data-card-frame') || '.cc-card__frame';
  var imgSel   = bar.getAttribute('data-card-img') || '.cc-card__img';
  var grid = document.querySelector(gridSel);
  if (!grid) return;

  var frames;
  try {
    frames = JSON.parse(dataEl.textContent || '{}');
  } catch (e) {
    return; // a malformed payload must not take the grid down with it
  }

  /* Collect the cards that can actually switch. A card with nothing to
     switch to is left entirely alone rather than given a dead control. */
  var cards = [];
  function collect() {
    cards = [];
    Array.prototype.forEach.call(grid.querySelectorAll(frameSel), function (frame) {
      var handle = frame.getAttribute('data-qv-handle');
      var set = handle && frames[handle];
      if (!set) return;
      var img = frame.querySelector(imgSel);
      if (!img) return;
      /* baseSrc is read the first time this card is seen. On a re-collect
         after a swap it would otherwise capture the mock-up as "the
         photograph" and there would be no way back to the work. */
      if (!frame.hasAttribute('data-cc-base')) {
        frame.setAttribute('data-cc-base', img.getAttribute('src') || '');
        frame.setAttribute('data-cc-baseset', img.getAttribute('srcset') || '');
      }
      cards.push({
        img: img,
        set: set,
        baseSrc: frame.getAttribute('data-cc-base'),
        baseSrcset: frame.getAttribute('data-cc-baseset')
      });
    });
  }
  collect();

  if (!cards.length) return; // nothing on this page carries the mock-up set

  bar.hidden = false;

  /* Shopify's CDN takes the size as a query parameter, so one URL at a known
     width yields the whole srcset by rewriting that number. Emitting five
     URLs per colour per product server-side would have quadrupled the
     payload for no gain. */
  function srcsetFor(url) {
    if (!url) return '';
    return WIDTHS.map(function (w) {
      return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Every switch bumps this. A decode that resolves after the viewer has
     already moved on carries a stale generation and is dropped, otherwise a
     slow first fetch can land on top of a newer choice and the grid ends up
     showing a colour nobody selected. Caught in testing: two switches 1.4s
     apart on a cold cache applied in the wrong order. */
  var generation = 0;

  /* The room shot for the colour in hand, else the first colour this print
     was actually shot in. Returns '' rather than guessing, and paint() then
     leaves the tile alone - the same rule as a missing frame colour. */
  function roomUrl(set) {
    var order = [lastColour].concat(ROOM_FALLBACK);
    for (var i = 0; i < order.length; i++) {
      var u = set['r' + order[i]];
      if (u) return u;
    }
    return '';
  }

  function paint(card, fmt, gen) {
    /* The photograph is restored from the attributes the card was SERVED
       with, not rebuilt by srcsetFor. cc-card-image.liquid emits its own
       srcset and a sizes that differs by orientation, and regenerating that
       from a single URL would quietly serve the wrong width back. */
    var isPhoto = fmt === 'photo';
    var url = isPhoto ? card.baseSrc : (fmt === 'room' ? roomUrl(card.set) : card.set[fmt]);
    if (!url) return;                          // no shot in this colour, leave it
    if (card.img.getAttribute('src') === url) return;  // already showing it

    var nextSrcset = isPhoto ? (card.baseSrcset || '') : srcsetFor(url);
    var next = new Image();
    next.srcset = nextSrcset;
    next.sizes = card.img.getAttribute('sizes') || '';
    next.src = url;

    var apply = function () {
      if (gen !== generation) return;  // the viewer has chosen again since
      if (nextSrcset) { card.img.setAttribute('srcset', nextSrcset); }
      else { card.img.removeAttribute('srcset'); }
      card.img.setAttribute('src', url);
      card.img.classList.remove('is-frameswapping');
    };

    if (reduce) { apply(); return; }

    card.img.classList.add('is-frameswapping');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      /* Clear the fade even on a stale generation, or a tile abandoned
         mid-swap would stay at opacity 0 for good. */
      if (gen !== generation) { card.img.classList.remove('is-frameswapping'); return; }
      apply();
    };

    if (next.decode) {
      next.decode().then(finish).catch(finish);
    } else {
      next.onload = finish;
      next.onerror = finish;
    }
    /* A file that never resolves must not leave a tile blank for good. */
    window.setTimeout(finish, 2000);
  }

  /* 28 Oct 2026, Charly: "mentioning what people see as same size that the
     current text on the same line". So the caption names the view you are
     looking at, beside "See every print", in the caption's own size - not a
     second line and not a smaller one. The caption is aria-hidden; the
     radio that is checked is what a screen reader reads. */
  var captionEl = bar.querySelector('[data-cc-frameswitch-state]');
  var captionBase = captionEl ? (captionEl.getAttribute('data-base') || '') : '';
  var STATE_WORDS = {
    photo: 'the photograph',
    blk: 'black frame',
    wht: 'white frame',
    nat: 'natural frame',
    room: 'in a room'
  };

  function sayState(fmt) {
    if (!captionEl) return;
    var word = STATE_WORDS[fmt] || '';
    if (fmt === 'room') {
      word = (STATE_WORDS[lastColour] || '') + ', in a room';
    }
    captionEl.textContent = word ? captionBase + ' \u00b7 ' + word : captionBase;
  }

  function setFormat(fmt, remember) {
    if (FORMATS.indexOf(fmt) === -1) fmt = 'photo';
    if (COLOURS.indexOf(fmt) !== -1) {
      lastColour = fmt;
      if (remember) {
        try { sessionStorage.setItem(COLOUR_KEY, fmt); } catch (e) { /* private window */ }
      }
    }
    generation += 1;
    var gen = generation;
    cards.forEach(function (card) { paint(card, fmt, gen); });
    grid.setAttribute('data-frame-view', fmt);
    sayState(fmt);
    current = fmt;
    if (remember) {
      try { sessionStorage.setItem(STORE_KEY, fmt); } catch (e) { /* private window */ }
    }
  }

  var current = 'photo';

  /* The shop grid can gain cards without a page load: cc-facets.js appends
     the rest of the collection the first time somebody filters. It merges
     the extra payload into #cc-frame-data and fires this, so a card that
     arrived after load switches like any other. Without it the appended
     half of the grid silently ignored the control. */
  document.addEventListener('cc:grid-updated', function () {
    try { frames = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
    collect();
    if (!cards.length) return;
    bar.hidden = false;
    setFormat(current, false);
  });

  bar.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.name || input.name !== 'cc-frame-view') return;
    setFormat(input.value, true);
  });

  /* The choice carries across collections, which is the point of a shop-wide
     view: picking Natural on Australia and then opening Brazil should not
     silently revert. Per viewer and per browser only - a convenience, not
     state anything depends on.

     2026-10-14: sessionStorage, NOT localStorage, by Charly's decision that
     a grid always opens on the photograph. In localStorage one tap on White
     outlived the visit, so a visitor who had glanced at a frame colour weeks
     ago came back to a shop of white-framed mock-ups on every grid and the
     homepage, with no control that meant "photograph" to undo it. That is
     the 25 Sep decision to put the photograph on the cards, reversed by a
     toggle. Now the preview lasts the visit and the next one starts on the
     work. */
  var saved = null;
  try { saved = sessionStorage.getItem(STORE_KEY); } catch (e) { /* ignore */ }

  if (saved && FORMATS.indexOf(saved) !== -1 && saved !== 'photo') {
    var input = bar.querySelector('input[value="' + saved + '"]');
    if (input) { input.checked = true; setFormat(saved, false); }
  } else {
    sayState('photo');
  }
})();
